import React from 'react';
import ReactDOM from 'react-dom/client';
//import CacheBuster from "react-cache-buster";
//import packageJson from "../package.json";

import { Provider } from 'react-redux';
import store from './store';


import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
//import ScreenLoaderHome from './components/common/ScreenLoaderHome';

/* const cacheBusterProps = {
  children: <App />,
  currentVersion: packageJson.version,
  isEnabled: true,
  //loadingComponent: <ScreenLoaderHome />,
  metaFileDirectory: "/", // location of version.json
}; */


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <CacheBuster {...cacheBusterProps} >
  <BrowserRouter>
    {/* <Provider store={store()}> */}
    <React.StrictMode>
      <App />
    </React.StrictMode>
    {/* </Provider> */}
  </BrowserRouter>
  // </CacheBuster>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
